import { render, staticRenderFns } from "./QLRadarDetail.vue?vue&type=template&id=b54c6e24&scoped=true"
import script from "./QLRadarDetail.vue?vue&type=script&lang=js"
export * from "./QLRadarDetail.vue?vue&type=script&lang=js"
import style0 from "./QLRadarDetail.vue?vue&type=style&index=0&id=b54c6e24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54c6e24",
  null
  
)

export default component.exports